/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
/** Custom Hooks */
import useDebounce from "../../app/customHooks/useDebounce";
/** CSS Files */
import "./Projects.scss";
/** Common Services & Data Files */
import MolGrid from "../../components/grid/MolGrid";
import { DropdownWrapper } from "../../components/ui/dropdownwrapper/DropdownWrapper";
import { encryptUrlData } from "../../services/CryptoService";
import SwalAlert from "../../services/swalService/SwalService";
import ToastService from "../../services/toastService/ToastService";
import CardSection from "../../components/ui/card/CardSection";
import Iconify from "../../layouts/components/iconify/iconify";
import Avatar from "../../components/ui/avatar/Avtar";
import { getProjectGradient } from "../../lib/getProjectGradient";
import Pagination from "../../components/ui/pagination/Pagination";
import { ProjectGridConfig } from "./config/Project.data";
/** RTK Query */
import {
  useDeleteProjectMutation,
  useGetAllProjectListMutation,
} from "../../app/services/projectManagementAPI";

const Projects = () => {
  const molGridRef = useRef();
  /* State*/
  const navigate = useNavigate();
  const { confirm } = SwalAlert();
  const [searchText, setSearchText] = useState("");
  const [projectGridData, setProjectGridData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);
  const organizationId = useSelector((state) => state.auth.user.organizationId);
  const [viewType, setViewType] = useState(
    localStorage.getItem("viewType") || "list"
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const debouncedSearch = useDebounce(searchText, 300);

  // API'S Call
  const [getAllProjectList, {
    isLoading: isProjectListLoading,
    isSuccess: isProjectListSuccess,
    data: isLProjectListeData,
  }] = useGetAllProjectListMutation();
  const [deleteProject, {
    isSuccess: isProjectDeleted,
    data: deleteProjectData
  }] = useDeleteProjectMutation();

  //** Funcation's */
  // Handlers to switch views
  const showListView = () => {
    setViewType("list");
    localStorage.setItem("viewType", "list");
  };

  const showCardView = () => {
    setViewType("card");
    localStorage.setItem("viewType", "card");
  };

  const getProjectDataList = (pageObject) => {
    getAllProjectList(pageObject);
  };

  const handlePageChange = (page) => {
    const newPage = page.pageNumber || page;
    const newPageSize = page.pageSize || pageSize;

    setCurrentPage(newPage);
    setPageSize(newPageSize);

    localStorage.setItem("currentPage", newPage);
    localStorage.setItem("pageSize", newPageSize);

    const request = {
      pagination: { pageNumber: newPage, pageSize: newPageSize },
      filters: { searchText: debouncedSearch },
      organizationId,
    };
    getProjectDataList(request);
  };

  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const addProjects = (data) => {
    navigate("/admin/AddProject");
  };

  const onEditAction = (data) => {
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("pageSize", pageSize);
    navigate(`/admin/project/EditProject/${encryptUrlData(data)}`);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProject(data.projectId);
      }
    });
  };

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  //** useEffect's */
  useEffect(() => {
    if (isProjectListSuccess && isLProjectListeData) {
      if (isLProjectListeData) {
        setProjectGridData(isLProjectListeData.dataSource);
      }
      if (isLProjectListeData.totalRecord) {
        setTotalRowCount(isLProjectListeData.totalRecord);
      }
    }
  }, [isProjectListSuccess, isLProjectListeData]);

  useEffect(() => {
    handlePageChange({ pageNumber: currentPage, pageSize });
  }, [debouncedSearch, currentPage, pageSize]);

  useEffect(() => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: debouncedSearch },
        organizationId: organizationId,
      };
      getProjectDataList(request);
    }
  }, [debouncedSearch, pageSize]);

  useEffect(() => {
    if (viewType === "card" && !projectGridData?.length) {
      getProjectDataList({
        pagination: { pageNumber: currentPage, pageSize: pageSize },
        filters: { searchText: debouncedSearch },
        organizationId,
      });
    }
  }, [viewType, currentPage, debouncedSearch]);

  useEffect(() => {
    if (isProjectDeleted && deleteProjectData) {
      ToastService.success(deleteProjectData.errorMessage);
      handlePageChange({ pageNumber: currentPage, pageSize });
    }
  }, [isProjectDeleted && deleteProjectData]);

  return (
    <div className="project-list center-top-space">
      <div className="list-view-section">
        <div className="table-grid">
          <div className="project-list">
            <CardSection
              isContentLoading={isProjectListLoading}
              cardTitle={"Project List"}
              rightButton={true}
              buttonClassName="theme-btn"
              titleButtonClick={addProjects}
              buttonText="Project"
              textWithIcon={true}
              iconName="material-symbols:add-rounded"
              fontIcon={true}
              searchInputName="Search by Project Name"
              handleChange={handleOnSearchChange}
              searchInput={true}
              isShorting={true}
              showListView={showListView}
              showCardView={showCardView}
              viewType={viewType}
            >
              {viewType === "card" ? (
                <div className="card-view">
                  <div className="row">
                    {projectGridData?.map((user, index) => {
                      const statusClass = user.isActive ? "active" : "inactive";
                      return (
                        <div className="project-main-card" key={user.projectId}>
                          <div className="project-card ">
                            <div className="card-part">
                              <div className="avatar-container">
                                <Avatar
                                  src=""
                                  alt={user.projectName}
                                  size="medium"
                                  shape="square"
                                  gradient={getProjectGradient(user.projectId)}
                                />
                                <div className="user-desc-status">
                                  <div
                                    className={`statusButton ${statusClass}`}
                                  ></div>
                                </div>
                                <div className="project-title">
                                  <h2 className="card-title">
                                    {user.projectName}
                                  </h2>

                                  <div className="customer-title">
                                    <Iconify icon="lets-icons:user-box-light" />
                                    {user.customerName}
                                  </div>
                                </div>
                              </div>
                              <div className="">
                                <DropdownWrapper
                                  direction="left"
                                  className="action-button-dropdown"
                                  toggleElement={
                                    <button className="customer-more-btn">
                                      <Iconify icon="humbleicons:dots-vertical" />
                                    </button>
                                  }
                                >
                                  <button
                                    onClick={() => actionHandler.EDIT(user)}
                                  >
                                    <Iconify icon="line-md:pencil" />
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => actionHandler.DELETE(user)}
                                  >
                                    <Iconify icon="mingcute:delete-2-line" />
                                    Delete
                                  </button>
                                </DropdownWrapper>
                              </div>
                            </div>
                            <div className="card-content">
                              <div className="time-period">
                                <div className="start-date date">
                                  <h4 className="date-lable">Start Date</h4>
                                  <p className="text-center">
                                    {user.projectStartDate &&
                                      moment(user.projectStartDate).format(
                                        "DD/MM/YYYY"
                                      )}
                                  </p>
                                </div>

                                <div className="start-date date">
                                  <h4 className="date-lable">Total Task</h4>
                                  {user.totalTaskCount}
                                </div>
                              </div>
                              <div className="bottom-sec">
                                <div className="avatar-container">
                                </div>
                              </div>
                            </div>
                            <div className="avatar-group-footer">
                              <Avatar
                                alt={user.customerName}
                                size="small"
                                shape="circle"
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <MolGrid
                  ref={molGridRef}
                  configuration={ProjectGridConfig}
                  dataSource={projectGridData}
                  allowPagination={true}
                  pagination={{
                    totalCount: totalRowCount,
                    currentPage,
                    pageSize,
                  }}
                  isLoading={isProjectListLoading}
                  onActionChange={actionHandler}
                  onPageChange={handlePageChange}
                />
              )}
            </CardSection>
            {viewType === "card" ? (
              <div className="pagination-container">
                <Pagination
                  currentPage={currentPage}
                  pageSize={pageSize}
                  totalCount={totalRowCount}
                  onPageChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
